let AuthUserData = {
    userid: "1001",
    Name: "User1",
    idtoken: "fefegwegefecefefefef",
    accesstoken: "fejhuygdysfbuysfuysfu",
    isAuthenticated: "False"
}

export default AuthUserData